import React from 'react'

const SvgPictureInPictureFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 5h14v3h2V5a2 2 0 00-2-2H4a2 2 0 00-2 2v11a2 2 0 002 2h4v-2H4V5z'
    />
    <path d='M10 12a2 2 0 012-2h8a2 2 0 012 2v7a2 2 0 01-2 2h-8a2 2 0 01-2-2v-7z' />
  </svg>
)

export default SvgPictureInPictureFilled
